import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addViewButton: {
		id: 'navigation-kit-add-tab.content.details.tab-details.add-view-button',
		defaultMessage: 'Add to navigation',
		description:
			'Label to primary button that confirms action to add selected view to the project navigation.',
	},
});
